import { lazy } from 'react';

export const YourNameLazy = lazy(() => import('./your-name'));
